import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const classService = {
    getAllClasses, 
    updateClassStatus,
    getClass,
    updateClass,
    createClass,
  };

const MODULE = {
    CLASS: 'rnd-classes',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'Class') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllClasses(filter) {
   
    const requestOptions = {
      params: {
        page: filter.pageNumber,
        size: filter.pageSize,
        name: filter.name,
        is_active: filter.isActive
      }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
      if(word != null || word != '')
      {
        var searchParam = `search_words[${index}]`
        requestOptions.params[searchParam] = word
      }
    })
    
    return apiHelper(API_URL).get(`/${MODULE.CLASS}`, requestOptions)
}


export function updateClassStatus(data) {
  const requestOptions = {
    is_active: data.isActive
  }

  return apiHelper(API_URL).patch(`/${MODULE.CLASS}/${data.id}`, requestOptions)
}

export async function getClass(id) {
  return await apiHelper(API_URL).get(`/${MODULE.CLASS}/${id}`)
}

export function updateClass(data) {
  const requestOptions = {
    name: data.name,
    is_active: data.isActive,
  }

  return apiHelper(API_URL).put(`/${MODULE.CLASS}/${data.id}`, requestOptions)
}

export function createClass(data) {
  const requestOptions = {
    name: data.name,
  }
  return apiHelper(API_URL).post(`/${MODULE.CLASS}`, requestOptions)
}